const messages = {
  title: "Hinnakirjad ja tootebrošüürid",
  description:
    "Laadige alla uusimad brošüürid ja flaiereid Bridgestone ja Firestone rehvide kohta sõiduautode, SUV-de ja väikekandurite jaoks.",
  brochureCategories: {
    products: "Tooted",
    brand_and_solutions: "Bränd ja lahendused",
    season_and_promotions: "Hooaeg ja kampaaniad",
    format: "Formaat",
    cars_and_vans: "Sõiduauto, SUV, väikekaubik",
    summer: "Suvi",
    winter: "Talv",
    promotions: "Kampaaniad",
    all_season: "Aastaringsed",
    truck_and_buses: "Veoauto ja buss",
    motorcycle: "Mootorratas",
    agriculture: "Põllumajandus",
    construction_machinery: "Ehitusmasinad",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materjalid",
    brochures: "Tootebrošüürid",
    price_list: "Hinnakirjad",
    materials: "Materjalid",
    video_in_store: "Video subtiitritega",
    video_online: "Video ilma subtiitriteta",
    banner_website: "Bänner",
    banner_social_media: "Sotsiaalmeedia",
    logos: "Logod",
  },
  searchMedia: "Sisesta märksõna",
  searchResults: "Otsingutulemused",
};

export default {
  messages,
};
